import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-col_view",
  "use": "icon-col_view-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"icon-col_view\">\n<rect x=\"2\" y=\"2\" width=\"9\" height=\"9\" />\n<rect x=\"13\" y=\"2\" width=\"9\" height=\"9\" />\n<rect x=\"2\" y=\"13\" width=\"9\" height=\"9\" />\n<rect x=\"13\" y=\"13\" width=\"9\" height=\"9\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol